
@if (!props.value) {
  <input
    type="text"
    [formControl]="formControl"
    maxLtvValidator
    class="form-control form-control-lg"
    [formlyAttributes]="field"
    [formlyAttributes]="field"
    [class.is-invalid]="showError"
    [class.is-valid]="(formControl.dirty || formControl.touched) && !showError"
    [attr.aria-describedby]="errorId + ' ' + errorDescriptionId"
    currencyMask
    />
} @else {
  <input type="text" class="form-control form-control-lg" [value]="props.value" disabled currencyMask maxLtvValidator />
}


<div id="{{ errorDescriptionId }}" class="sr-only">
  {{ valid ? 'valid input' : '' }}
  {{ invalid ? 'invalid input' : '' }}
</div>
